export const formEl = [
  {
    label: 'Single Textbox',
    value: 'text',
  },

  {
    label: 'Multple Choice',
    value: 'radio',
  },
  {
    label: 'Checkboxes',
    value: 'checkbox',
  },
  {
    label: 'Dropdown',
    value: 'dropdown',
  },
  {
    label: 'Slider',
    value: 'slider',
  },

];
